module.exports = __webpack_public_path__ + "static/media/modalImg5.049e51c6.png";